import { render } from "./MediaDocs.vue?vue&type=template&id=3e30ba0b&scoped=true&ts=true"
import script from "./MediaDocs.vue?vue&type=script&lang=ts"
export * from "./MediaDocs.vue?vue&type=script&lang=ts"

import "./MediaDocs.vue?vue&type=style&index=0&id=3e30ba0b&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e30ba0b"]])

export default __exports__